<template>
	<form
		class="search__topo"
		ref="$form"
		@click.stop
	>
		<input type="hidden" name="categoria" value="todas">

		<div
			class="search__topo__field"
			:class="{
				'search__topo__field--shown': open
			}"
			ref="$field"
			@transitionend="onTransitionEnd"
		>
			<input
				type="text"
				name="search"
				placeholder="O que você procura?"
				class="search__topo__input"
				ref="$input"
			>
		</div>

		<button
			type="button"
			class="search__topo__btn"
			@click="onClick"
			:disabeld="transition"
		>
			<i class="fa-solid fa-search"></i>
		</button>
	</form>
</template>

<script setup>
import { ref, onMounted } from 'vue'

//===============================
// DATA
//===============================
const open       = ref(false)
const transition = ref(false)

//===============================
// REF ELEMENTS
//===============================
const $form  = ref(null)
const $field = ref(null)
const $input = ref(null)


//===============================
// METHODS
//===============================
const onClick = $event => {
	$event.stopPropagation()

	if (open.value && !transition.value) return $form.value.submit()

	return open.value = transition.value = true
}

const onTransitionEnd = () => {
	transition.value = false

	if(open.value) $input.value.focus()
}

//===============================
// HOOKS
//===============================
onMounted(() => {
	window.addEventListener('click', ({ target }) => {
		open.value = false
		transition.value = true
	})
})
</script>
